module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.detailPage == 1) ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row-header",
    staticStyle: {
      "height": "38px",
      "overflow": "hidden",
      "display": "flex",
      "justify-content": "space-between"
    },
    attrs: {
      "id": "title-danhsach"
    }
  }, [_c('div', {
    staticClass: "background-triangle-big view_tp_pdf"
  }, [_c('span', [_vm._v("Tra cứu thông tin " + _vm._s(_vm.module["pathParent"]))])]), _vm._v(" "), _c('div', {
    staticClass: "collapsible1 mr-3",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "color": "blue"
    },
    on: {
      "click": function($event) {
        _vm.isToggle = !_vm.isToggle
      }
    }
  }, [_vm._v("Tìm kiếm "), (!_vm.isToggle) ? _c('i', {
    staticClass: "mdi mdi-chevron-down"
  }) : _vm._e(), (_vm.isToggle) ? _c('i', {
    staticClass: "mdi mdi-chevron-up"
  }) : _vm._e()])])]), _vm._v(" "), (_vm.isToggle) ? _c('div', {
    staticClass: "collapsible-content pb-1",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('v-layout', {
    staticClass: "ml-0",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "margin-top": "4px",
      "font-size": "13px",
      "text-align": "right",
      "padding-right": "10px"
    },
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('span', {
    staticClass: "text-xs-right"
  }, [_vm._v("Hình thức tra cứu: ")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "margin-top": "4px",
      "font-size": "13px",
      "padding-right": "10px"
    },
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chooseTypeTraCuu),
      expression: "chooseTypeTraCuu"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "radio",
      "id": "tt",
      "value": "tt"
    },
    domProps: {
      "checked": _vm._q(_vm.chooseTypeTraCuu, "tt")
    },
    on: {
      "click": function($event) {
        return _vm.clickTypeTraCuu()
      },
      "change": function($event) {
        _vm.chooseTypeTraCuu = "tt"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "tt"
    }
  }, [_c('b', [_vm._v("Kết quả thủ tục hành chính")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chooseTypeTraCuu),
      expression: "chooseTypeTraCuu"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "radio",
      "id": "dt",
      "value": "dt"
    },
    domProps: {
      "checked": _vm._q(_vm.chooseTypeTraCuu, "dt")
    },
    on: {
      "click": function($event) {
        return _vm.clickTypeTraCuu()
      },
      "change": function($event) {
        _vm.chooseTypeTraCuu = "dt"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "dt"
    }
  }, [_c('b', [_vm._v("Phương tiện SXLR")])])]), _vm._v(" "), (_vm.chooseTypeTraCuu == 'tt') ? _c('v-flex', {
    staticStyle: {
      "margin-top": "4px",
      "font-size": "13px",
      "text-align": "right",
      "padding-right": "10px"
    },
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('span', {
    staticClass: "text-xs-right"
  }, [_vm._v("Chọn Thủ tục hành chính: ")])]) : _vm._e(), _vm._v(" "), (_vm.chooseTypeTraCuu == 'tt') ? _c('v-flex', {
    staticClass: "pr-1",
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.modules,
      "return-object": "",
      "item-text": "name",
      "item-value": "module",
      "autocomplete": "",
      "placeholder": "Tên Module"
    },
    on: {
      "input": function($event) {
        return _vm.selectModuleAction()
      }
    },
    model: {
      value: (_vm.selectModule),
      callback: function($$v) {
        _vm.selectModule = $$v
      },
      expression: "selectModule"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.chooseTypeTraCuu == 'dt') ? _c('v-flex', {
    staticStyle: {
      "margin-top": "4px",
      "font-size": "13px",
      "text-align": "right",
      "padding-right": "10px"
    },
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('span', {
    staticClass: "text-xs-right"
  }, [_vm._v("Chọn đối tượng: ")])]) : _vm._e(), _vm._v(" "), (_vm.chooseTypeTraCuu == 'dt') ? _c('v-flex', {
    staticClass: "pr-1",
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.objectPT,
      "return-object": "",
      "item-text": "name",
      "item-value": "module",
      "autocomplete": "",
      "placeholder": "Tên đối tượng"
    },
    on: {
      "input": function($event) {
        return _vm.selectObjectPTAction()
      }
    },
    model: {
      value: (_vm.selectObjectPT),
      callback: function($$v) {
        _vm.selectObjectPT = $$v
      },
      expression: "selectObjectPT"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.chooseTypeTraCuu != 0) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md3": ""
    }
  }, [_c('div', [_c('span', {
    staticStyle: {
      "float": "right",
      "padding-right": "10px",
      "font-size": "13px",
      "margin-top": "7px"
    }
  }, [_vm._v("Điều kiện tìm kiếm:\n          ")])])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-1",
    attrs: {
      "xs12": "",
      "sm9": "",
      "md9": ""
    }
  }, _vm._l((_vm.listSearch), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "filter-item",
      staticStyle: {
        "clear": "both",
        "display": "flex"
      }
    }, [(_vm.chooseTypeTraCuu != 0) ? _c('v-autocomplete', {
      staticClass: "pr-2 pt-0",
      staticStyle: {
        "display": "inline-block",
        "width": "36%",
        "float": "left"
      },
      attrs: {
        "outlined": "",
        "autocomplete": "",
        "items": _vm.conditions,
        "item-text": "value",
        "clearable": "",
        "return-object": ""
      },
      on: {
        "input": function($event) {
          return _vm.changeCondition(item)
        }
      },
      model: {
        value: (item['conditionsSelect']),
        callback: function($$v) {
          _vm.$set(item, 'conditionsSelect', $$v)
        },
        expression: "item['conditionsSelect']"
      }
    }) : _vm._e(), _vm._v(" "), (
      item['conditionsSelect'] &&
      (item['conditionsSelect']['type'] === 'string' ||
        item['conditionsSelect']['type'] === 'keyword')
    ) ? _c('v-text-field', {
      staticClass: "pr-1 pt-0",
      staticStyle: {
        "display": "inline-block",
        "width": "35%"
      },
      attrs: {
        "outlined": "",
        "placeholder": "Nhập từ khóa"
      },
      model: {
        value: (item['valueSearch']),
        callback: function($$v) {
          _vm.$set(item, 'valueSearch', $$v)
        },
        expression: "item['valueSearch']"
      }
    }) : _vm._e(), _vm._v(" "), (
      item['conditionsSelect'] &&
      item['conditionsSelect']['type'] === 'number'
    ) ? _c('v-text-field', {
      staticClass: "pt-0",
      staticStyle: {
        "display": "inline-block",
        "width": "35%"
      },
      attrs: {
        "outlined": "",
        "type": "number",
        "placeholder": "Nhập số"
      },
      model: {
        value: (item['valueSearch']),
        callback: function($$v) {
          _vm.$set(item, 'valueSearch', $$v)
        },
        expression: "item['valueSearch']"
      }
    }) : _vm._e(), _vm._v(" "), (
      item['conditionsSelect'] &&
      item['conditionsSelect']['type'] === 'date'
    ) ? _c('v-menu', {
      ref: "menuDateTraCuuFrom",
      refInFor: true,
      staticStyle: {
        "width": "30%",
        "display": "normal"
      },
      attrs: {
        "close-on-content-click": false,
        "nudge-right": 40,
        "return-value": _vm.date,
        "lazy": "",
        "transition": "scale-transition",
        "offset-y": "",
        "full-width": ""
      },
      on: {
        "update:returnValue": function($event) {
          _vm.date = $event
        },
        "update:return-value": function($event) {
          _vm.date = $event
        }
      },
      model: {
        value: (_vm.menuDateTraCuuFrom),
        callback: function($$v) {
          _vm.menuDateTraCuuFrom = $$v
        },
        expression: "menuDateTraCuuFrom"
      }
    }, [_c('v-text-field', {
      staticClass: "pt-0 pr-1",
      attrs: {
        "slot": "activator",
        "append-icon": "event",
        "clearable": "",
        "readonly": ""
      },
      slot: "activator",
      model: {
        value: (item['fromDate']),
        callback: function($$v) {
          _vm.$set(item, 'fromDate', $$v)
        },
        expression: "item['fromDate']"
      }
    }), _vm._v(" "), _c('v-date-picker', {
      on: {
        "input": function($event) {
          return _vm.parseDateTraCuuFrom(item)
        }
      },
      model: {
        value: (item['fromDateTraCuu']),
        callback: function($$v) {
          _vm.$set(item, 'fromDateTraCuu', $$v)
        },
        expression: "item['fromDateTraCuu']"
      }
    })], 1) : _vm._e(), _vm._v(" "), (
      item['conditionsSelect'] &&
      item['conditionsSelect']['type'] === 'date'
    ) ? _c('v-menu', {
      ref: "menuDateTraCuuTo",
      refInFor: true,
      staticStyle: {
        "width": "28%",
        "display": "normal"
      },
      attrs: {
        "close-on-content-click": false,
        "nudge-right": 40,
        "return-value": _vm.date,
        "lazy": "",
        "transition": "scale-transition",
        "offset-y": "",
        "full-width": ""
      },
      on: {
        "update:returnValue": function($event) {
          _vm.date = $event
        },
        "update:return-value": function($event) {
          _vm.date = $event
        }
      },
      model: {
        value: (_vm.menuDateTraCuuTo),
        callback: function($$v) {
          _vm.menuDateTraCuuTo = $$v
        },
        expression: "menuDateTraCuuTo"
      }
    }, [_c('v-text-field', {
      staticClass: "pt-0",
      attrs: {
        "slot": "activator",
        "append-icon": "event",
        "clearable": "",
        "readonly": ""
      },
      slot: "activator",
      model: {
        value: (item['toDate']),
        callback: function($$v) {
          _vm.$set(item, 'toDate', $$v)
        },
        expression: "item['toDate']"
      }
    }), _vm._v(" "), _c('v-date-picker', {
      on: {
        "input": function($event) {
          return _vm.parseDateTraCuuTo(item)
        }
      },
      model: {
        value: (item['toDateTraCuu']),
        callback: function($$v) {
          _vm.$set(item, 'toDateTraCuu', $$v)
        },
        expression: "item['toDateTraCuu']"
      }
    })], 1) : _vm._e(), _vm._v(" "), (
      item['conditionsSelect'] &&
      item['conditionsSelect']['type'] === 'select'
    ) ? _c('v-autocomplete', {
      staticClass: "pt-0",
      staticStyle: {
        "display": "inline-block",
        "width": "30%"
      },
      attrs: {
        "items": item['conditionsSelect']['items'],
        "outlined": "",
        "autocomplete": "",
        "item-text": "itemText",
        "item-value": "itemValue"
      },
      model: {
        value: (item['valueSearch']),
        callback: function($$v) {
          _vm.$set(item, 'valueSearch', $$v)
        },
        expression: "item['valueSearch']"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.chooseTypeTraCuu != 0) ? _c('v-chip', {
      staticClass: "mt-2",
      staticStyle: {
        "height": "22px",
        "float": "right",
        "cursor": "pointer"
      },
      attrs: {
        "label": ""
      },
      on: {
        "click": function($event) {
          return _vm.removeSearch(item, index)
        }
      }
    }, [_c('v-icon', {
      staticStyle: {
        "font-size": "17px",
        "cursor": "pointer"
      },
      attrs: {
        "size": "18",
        "color": "red"
      }
    }, [_vm._v("delete_outline")])], 1) : _vm._e(), _vm._v(" "), _c('br')], 1)
  }), 0), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs12": "",
      "sm7": ""
    }
  }, [_c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addSearch()
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#fff",
      "font-size": "17px"
    },
    attrs: {
      "size": "17"
    }
  }, [_vm._v("add")]), _vm._v("\n          Thêm điều kiện")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.traCuuThongKe()
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#fff",
      "font-size": "17px"
    },
    attrs: {
      "size": "17"
    }
  }, [_vm._v("search")]), _vm._v("\n          Tìm kiếm")], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "flex-end"
    },
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('span', {
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_c('i', [_vm._v("Tổng số: ")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.totalTraCuu))])]), _vm._v(" "), _c('v-pagination', {
    attrs: {
      "total-visible": 7,
      "length": _vm.lengthPageTraCuuThongKe
    },
    on: {
      "input": _vm.pagingTraCuu
    },
    model: {
      value: (_vm.pageTraCuuThongKe),
      callback: function($$v) {
        _vm.pageTraCuuThongKe = $$v
      },
      expression: "pageTraCuuThongKe"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "ml-0",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingTableTraCuu),
      expression: "loadingTableTraCuu"
    }],
    staticClass: "text-xs-center",
    staticStyle: {
      "width": "100%",
      "background": "#fff"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 30,
      "width": 2,
      "color": "purple"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n        Đang tải dữ liệu\n      ")], 1), _vm._v(" "), _c('v-data-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingTableTraCuu),
      expression: "!loadingTableTraCuu"
    }],
    attrs: {
      "headers": _vm.headersTraCuu,
      "items": _vm.listsTraCuu,
      "loading": _vm.loadingTableTraCuu,
      "loading-text": "Đang tải dữ liệu, vui lòng chờ giây lát!",
      "no-data-text": "Không có dữ liệu",
      "hide-default-header": false,
      "hide-default-footer": "",
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', _vm._l((_vm.headersTraCuu), function(itemHeader, index) {
          return _c('td', {
            staticClass: "text-xs-center"
          }, [(itemHeader['display'] === 'stt') ? _c('span', [_vm._v(_vm._s(_vm.pageTraCuuThongKe * 20 - 20 + props.index + 1))]) : (itemHeader['display'] === 'action') ? _c('div', [(_vm.chooseTypeTraCuu === 'tt') ? _c('v-chip', {
            attrs: {
              "small": "",
              "label": "",
              "outline": "",
              "color": "blue",
              "disabled": !props.item['deliverableFileEntryId'] ||
                props.item['deliverableFileEntryId'] === '0'
            },
            on: {
              "click": function($event) {
                return _vm.xemGiayChungNhan(props.item)
              }
            }
          }, [_c('v-icon', {
            staticStyle: {
              "font-size": "15px"
            },
            attrs: {
              "size": "17",
              "color": props.item['vr_VehicleTypeCertificate'] &&
                props.item['vr_VehicleTypeCertificate'][
                  'deliverableFileEntryId'
                ] &&
                props.item['vr_VehicleTypeCertificate'][
                  'deliverableFileEntryId'
                ] !== '0' ?
                'green' :
                'red'
            }
          }, [_vm._v("\n                    " + _vm._s(props.item["vr_VehicleTypeCertificate"] &&
            props.item["vr_VehicleTypeCertificate"][
              "deliverableFileEntryId"
            ] &&
            props.item["vr_VehicleTypeCertificate"][
              "deliverableFileEntryId"
            ] !== "0" ?
            "done" :
            "cancel") + "\n                  ")]), _vm._v(" "), _c('span', {
            staticStyle: {
              "cursor": "pointer"
            }
          }, [_vm._v("Xem GCN")])], 1) : _vm._e(), _vm._v(" "), (_vm.chooseTypeTraCuu === 'tt') ? _c('br') : _vm._e(), _vm._v(" "), (_vm.chooseTypeTraCuu === 'tt') ? _c('v-chip', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "small": "",
              "label": "",
              "outline": "",
              "color": "blue"
            },
            on: {
              "click": function($event) {
                return _vm.xemTSKT(props.item)
              }
            }
          }, [_c('v-icon', {
            staticStyle: {
              "font-size": "15px"
            },
            attrs: {
              "size": "17",
              "color": _vm.green
            }
          }, [_vm._v("\n                    " + _vm._s("done") + "\n                  ")]), _vm._v(" "), _c('span', {
            staticStyle: {
              "cursor": "pointer"
            }
          }, [_vm._v("Xem TSKT")])], 1) : _vm._e(), _vm._v(" "), (_vm.chooseTypeTraCuu === 'tt' && props.item['vr_VehicleTypeCertificate']['serviceCode'] === 'TT302011BGTVTTDTKXCG') ? _c('br') : _vm._e(), _vm._v(" "), (_vm.chooseTypeTraCuu === 'tt' && props.item['vr_VehicleTypeCertificate']['serviceCode'] === 'TT302011BGTVTTDTKXCG') ? _c('v-chip', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "small": "",
              "label": "",
              "outline": "",
              "color": "blue"
            },
            on: {
              "click": function($event) {
                return _vm.viewBanVe(props.item)
              }
            }
          }, [_c('v-icon', {
            staticStyle: {
              "font-size": "15px"
            },
            attrs: {
              "size": "17",
              "color": _vm.green
            }
          }, [_vm._v("\n                    " + _vm._s("done") + "\n                  ")]), _vm._v(" "), _c('span', {
            staticStyle: {
              "cursor": "pointer"
            }
          }, [_vm._v("Xem Bản Vẽ")])], 1) : _vm._e(), _vm._v(" "), (_vm.chooseTypeTraCuu === 'tt') ? _c('br') : _vm._e(), _vm._v(" "), (_vm.chooseTypeTraCuu === 'tt') ? _c('v-chip', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "small": "",
              "label": "",
              "outline": "",
              "color": "blue"
            },
            on: {
              "click": function($event) {
                return _vm.viewListAnh(props.item, 1)
              }
            }
          }, [_c('v-icon', {
            staticStyle: {
              "font-size": "15px"
            },
            attrs: {
              "size": "17",
              "color": _vm.green
            }
          }, [_vm._v("\n                    " + _vm._s("done") + "\n                  ")]), _vm._v(" "), _c('span', {
            staticStyle: {
              "cursor": "pointer"
            }
          }, [_vm._v("Xem Ảnh SP")])], 1) : _vm._e(), _vm._v(" "), (_vm.chooseTypeTraCuu === 'dt') ? _c('v-chip', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "small": "",
              "label": "",
              "outline": "",
              "color": "blue"
            },
            on: {
              "click": function($event) {
                return _vm.xemThongTinPXX(props.item)
              }
            }
          }, [_c('v-icon', {
            staticStyle: {
              "font-size": "15px"
            },
            attrs: {
              "size": "17",
              "color": _vm.green
            }
          }, [_vm._v("\n                    " + _vm._s("done") + "\n                  ")]), _vm._v(" "), _c('span', {
            staticStyle: {
              "cursor": "pointer"
            }
          }, [_vm._v("Xem Thông tin PXX")])], 1) : _vm._e(), _vm._v(" "), (_vm.chooseTypeTraCuu === 'dt') ? _c('v-chip', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "small": "",
              "label": "",
              "outline": "",
              "color": "blue"
            },
            on: {
              "click": function($event) {
                return _vm.xemTSKT2(props.item)
              }
            }
          }, [_c('v-icon', {
            staticStyle: {
              "font-size": "15px"
            },
            attrs: {
              "size": "17",
              "color": _vm.green
            }
          }, [_vm._v("\n                    " + _vm._s("done") + "\n                  ")]), _vm._v(" "), _c('span', {
            staticStyle: {
              "cursor": "pointer"
            }
          }, [_vm._v("Xem TSKT")])], 1) : _vm._e(), _vm._v(" "), (_vm.chooseTypeTraCuu === 'dt') ? _c('v-chip', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "small": "",
              "label": "",
              "outline": "",
              "color": "blue"
            },
            on: {
              "click": function($event) {
                return _vm.viewBanVe(props.item)
              }
            }
          }, [_c('v-icon', {
            staticStyle: {
              "font-size": "15px"
            },
            attrs: {
              "size": "17",
              "color": _vm.green
            }
          }, [_vm._v("\n                    " + _vm._s("done") + "\n                  ")]), _vm._v(" "), _c('span', {
            staticStyle: {
              "cursor": "pointer"
            }
          }, [_vm._v("Xem Bản Vẽ")])], 1) : _vm._e(), _vm._v(" "), (_vm.chooseTypeTraCuu === 'dt') ? _c('v-chip', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "small": "",
              "label": "",
              "outline": "",
              "color": "blue"
            },
            on: {
              "click": function($event) {
                return _vm.viewListAnh(props.item, 2)
              }
            }
          }, [_c('v-icon', {
            staticStyle: {
              "font-size": "15px"
            },
            attrs: {
              "size": "17",
              "color": _vm.green
            }
          }, [_vm._v("\n                    " + _vm._s("done") + "\n                  ")]), _vm._v(" "), _c('span', {
            staticStyle: {
              "cursor": "pointer"
            }
          }, [_vm._v("Xem Ảnh SP")])], 1) : _vm._e()], 1) : (itemHeader['display'] === 'vr_VehicleTypeCertificate.certificateRecordNo' || itemHeader['display'] === 'vr_VehicleTypeCertificate.certificateRecordDate') ? _c('span', [(props.item['vr_VehicleTypeCertificate'] && props.item['vr_VehicleTypeCertificate']['certificateRecordStatus'] === 2 || props.item['vr_VehicleTypeCertificate']['certificateRecordStatus'] === '2' || props.item['vr_VehicleTypeCertificate']['certificateRecordStatus'] === 3 || props.item['vr_VehicleTypeCertificate']['certificateRecordStatus'] === '3') ? _c('span', [_vm._v("\n                  " + _vm._s(_vm.getDisplay(props.item, itemHeader['display'], itemHeader['type'])) + "\n                ")]) : _vm._e()]) : (itemHeader['display'] === 'vr_VehicleTypeCertificate.urbanCycle' || itemHeader['display'] === 'vr_VehicleTypeCertificate.ruralCycle' || itemHeader['display'] === 'vr_VehicleTypeCertificate.combinedCycle') ? _c('span', [_c('span', [_vm._v("\n                  " + _vm._s(_vm.getDisplay2(props.item, itemHeader['display'], itemHeader['display2'])) + "\n                ")])]) : _c('span', [_vm._v(_vm._s(_vm.getDisplay(
            props.item,
            itemHeader["display"],
            itemHeader["type"]
          )))])])
        }), 0)]
      }
    }], null, false, 1743516853)
  })], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "fullscreen": "",
      "hide-overlay": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: (_vm.dialogTSKT),
      callback: function($$v) {
        _vm.dialogTSKT = $$v
      },
      expression: "dialogTSKT"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticStyle: {
      "height": "63px",
      "background": "#2c4577",
      "color": "#fff",
      "font-size": "20px",
      "position": "relative"
    }
  }, [_vm._v("\n        Thông số kỹ thuật\n        "), _c('v-btn', {
    staticClass: "mx-0 my-0",
    staticStyle: {
      "position": "absolute",
      "right": "19px"
    },
    attrs: {
      "dark": "",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogTSKT = false
      }
    }
  }, [_c('v-icon', [_vm._v("clear")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "690px",
      "overflow": "auto"
    }
  }, [(_vm.loadingDialog) ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": true
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "width": "100%",
      "background": "#fff"
    }
  }, [_c('v-expansion-panel', {
    staticClass: "my-0 opencps-dossier-info",
    attrs: {
      "expand": ""
    }
  }, [_c('v-layout', {
    staticClass: "ml-0 pl-0",
    staticStyle: {
      "padding-right": "15px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('span', [_vm._v("Số chứng chỉ")]), _vm._v(": "), _c('label', [_vm._v(_vm._s(_vm.thongTinChungTSKT['certificateRecordNo']))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('span', [_vm._v("Ngày ký")]), _vm._v(": "), _c('label', [_vm._v(_vm._s(_vm.parseTimeStampToDate(_vm.thongTinChungTSKT['certificateRecordDate'])))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('span', [_vm._v("Đăng kiểm viên chính")]), _vm._v(": "), _c('label', [_vm._v(_vm._s(_vm.thongTinChungTSKT['inspectorName'] || _vm.thongTinChungTSKT['inspectorSignName']))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('span', [_vm._v("Số biên bản kiểm tra")]), _vm._v(": "), _c('label', [_vm._v(_vm._s(_vm.thongTinChungTSKT['inspectionRecordNo'] || _vm.thongTinChungTSKT['verificationRefNo']))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('span', [_vm._v("Ngày kiểm tra")]), _vm._v(": "), _c('label', [_vm._v(_vm._s(_vm.thongTinChungTSKT['inspectionRecordNo'] ? _vm.parseTimeStampToDate(_vm.thongTinChungTSKT['inspectionDate']) : _vm.parseTimeStampToDate(_vm.thongTinChungTSKT['verificationRefDate'])))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('span', [_vm._v("Loại hồ sơ")]), _vm._v(": "), _c('label', [_vm._v(_vm._s(_vm.thongTinChungTSKT['dossierTypeDescription']))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }), _vm._v(" "), (_vm.thongTinChungTSKT['serviceCode'] == 'TT302011BGTVTTDTKXCG' && _vm.thongTinChungTSKT['designModelDescription']) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_vm._v("\n                  Loại hình thiết kế: "), _c('label', [_vm._v(_vm._s(_vm.thongTinChungTSKT['designModelDescription']))])]) : _vm._e(), _vm._v(" "), (_vm.thongTinChungTSKT['serviceCode'] == 'TT302011BGTVTTDTKXCG') ? [_c('v-layout', {
    staticClass: "ml-0 pl-0",
    staticStyle: {
      "padding-right": "15px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("1. THÔNG TIN CHUNG")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('table', {
    staticClass: "table-basic px-4 pb-2 table-tskt",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("TT")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Hạng mục")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Nội dung")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('label', [_vm._v("1.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Cơ sở thiết kế")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Tên")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['applicantName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Địa chỉ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['applicantAddress']))])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v("2.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Cơ sở sản xuất lắp ráp, nhập khẩu")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Tên")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['manufacturerName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Địa chỉ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['manufacturerAddress']))])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v("5.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin chung về kiểu loại xe")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Ký hiệu thiết kế")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['designSymbol']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Loại phương tiện")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedVehicleTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Nhãn hiệu")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedTrademarkName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.4. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Tên thương mại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedCommercialName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.5. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Mã kiểu loại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedModelCode']))])])])])])], 1)] : (_vm.listServiceToanXe.includes(_vm.thongTinChungTSKT['serviceCode'])) ? [_c('v-layout', {
    staticClass: "ml-0 pl-0",
    staticStyle: {
      "padding-right": "15px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("1. THÔNG TIN CHUNG")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('table', {
    staticClass: "table-basic px-4 pb-2 table-tskt",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("TT")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Hạng mục")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Nội dung")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('label', [_vm._v("1.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin về cơ sở sản xuất")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Cơ sở sản xuất, lắp ráp")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['applicantName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.1.1 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Địa chỉ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['applicantAddress']))])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v("6.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin chung về kiểu loại xe")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("6.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Loại phương tiện")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedVehicleTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("6.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Nhãn hiệu")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedTrademarkName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("6.3. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Tên thương mại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedCommercialName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("6.4. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Mã kiểu loại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedModelCode']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("6.5. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Loại hình sản xuất, lắp ráp")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedAssemblyTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("6.6. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Mã số VIN")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedVINNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("6.6.1 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Mô tả vị trí đóng")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedVINPosition']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("6.7. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Mã số khung")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedFrameNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("6.7.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Nơi đóng số khung")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedFrameAttachPlace']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("6.8. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Mã số động cơ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedEngineNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("6.8.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Nơi đóng số động cơ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedEngineAttachPlace']))])])])])])], 1)] : (_vm.listServiceLinhKien.includes(_vm.thongTinChungTSKT['serviceCode'])) ? [_c('v-layout', {
    staticClass: "ml-0 pl-0",
    staticStyle: {
      "padding-right": "15px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("1. THÔNG TIN CHUNG")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('table', {
    staticClass: "table-basic px-4 pb-2 table-tskt",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("TT")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Hạng mục")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Nội dung")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('label', [_vm._v("1.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin về cơ sở sản xuất")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Cơ sở sản xuất, lắp ráp")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['applicantName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.1.1 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Địa chỉ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['applicantAddress']))])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v("5.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin chung về kiểu loại sản phẩm")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Loại sản phẩm")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedVehicleTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Nhãn hiệu")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedTrademarkName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Tên thương mại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedCommercialName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.4. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Mã kiểu loại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedModelCode']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.5. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Loại hình sản xuất, lắp ráp")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedAssemblyTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.5. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Ký hiệu thiết kế/ ký hiệu sản phẩm")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n                              " + _vm._s(_vm.thongTinChungTSKT['designSymbol']) + "\n                            ")])])])])])], 1)] : (_vm.listServiceSPM.includes(_vm.thongTinChungTSKT['serviceCode'])) ? [_c('v-layout', {
    staticClass: "ml-0 pl-0",
    staticStyle: {
      "padding-right": "15px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("1. THÔNG TIN CHUNG")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('table', {
    staticClass: "table-basic px-4 pb-2 table-tskt",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("TT")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Hạng mục")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Nội dung")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('label', [_vm._v("1.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin về cơ sở sản xuất")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Cơ sở sản xuất, lắp ráp")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['applicantName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Địa chỉ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['applicantAddress']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.3. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Nhà máy sản xuất")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n                              " + _vm._s(_vm.thongTinChungTSKT['productionPlantName']) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.4. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Địa chỉ nhà máy sản xuất")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['productionPlantAddress']))])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v("2.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin về chứng chỉ thẩm định thiết kế")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Số chứng chỉ thẩm định thiết kế")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['verificationCertificateNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Ngày cấp")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.parseTimeStampToDate(_vm.thongTinChungTSKT['verificationCertificateDate'])))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.3. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Ký hiệu thiết kế")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['designSymbol']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.4. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Số giấy chứng nhận phê duyệt kiểu loại tại nước ngoài")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['typeApprovalCertificateNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.4. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Ngày cấp")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.parseTimeStampToDate(_vm.thongTinChungTSKT['typeApprovalCertificateDate'])))])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v("3.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin tiêu chuẩn, quy chuẩn áp dụng")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("3.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Tiêu chuẩn an toàn chung")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['commonSafetyDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("3.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Tiêu chuẩn khí thải")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['emissionDescription']))])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v("4.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin chung về kiểu loại xe")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("4.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Loại hình sản xuất, lắp ráp")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedAssemblyTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("4.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Loại phương tiện")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedVehicleTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Nhãn hiệu")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedTrademarkName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("4.4. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Tên thương mại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedCommercialName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("4.5. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Mã kiểu loại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedModelCode']))])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v("5.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin xe mẫu, loại xe cở sở")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Số khung xe mẫu (số VIN)")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleVINNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Số động cơ xe mẫu")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleEngineNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Xe ô tô cơ sở (áp dụng cho xe đóng thùng)")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleVehicleTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3.1 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Số GCN xe cơ sở")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['referenceCertificateNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3.2 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Loại xe ô tô cơ sở")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleVehicleTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3.3 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Nhãn hiệu")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleTrademarkName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3.4 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Tên thương mại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleCommercialName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3.5 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Mã kiểu loại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleModelCode']))])])])])])], 1)] : [_c('v-layout', {
    staticClass: "ml-0 pl-0",
    staticStyle: {
      "padding-right": "15px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("1. THÔNG TIN CHUNG")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('table', {
    staticClass: "table-basic px-4 pb-2 table-tskt",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("TT")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Hạng mục")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Nội dung")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('label', [_vm._v("1.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin về cơ sở sản xuất")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Cơ sở sản xuất, lắp ráp")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['applicantName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Địa chỉ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['applicantAddress']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.3. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Nhà máy sản xuất")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n                              " + _vm._s(_vm.thongTinChungTSKT['productionPlantName']) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.4. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Địa chỉ nhà máy sản xuất")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['productionPlantAddress']))])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v("2.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin về chứng chỉ thẩm định thiết kế")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Số chứng chỉ thẩm định thiết kế")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['verificationCertificateNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Ngày cấp")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.parseTimeStampToDate(_vm.thongTinChungTSKT['verificationCertificateDate'])))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.3. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Ký hiệu thiết kế")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['designSymbol']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.4. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Số giấy chứng nhận phê duyệt kiểu loại tại nước ngoài")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['typeApprovalCertificateNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.4. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Ngày cấp")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.parseTimeStampToDate(_vm.thongTinChungTSKT['typeApprovalCertificateDate'])))])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v("3.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin tiêu chuẩn, quy chuẩn áp dụng")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("3.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Tiêu chuẩn an toàn chung")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['commonSafetyDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("3.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Tiêu chuẩn khí thải")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['emissionDescription']))])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v("4.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin chung về kiểu loại xe")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("4.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Loại hình sản xuất, lắp ráp")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedAssemblyTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("4.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Loại phương tiện")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedVehicleTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Nhãn hiệu")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedTrademarkName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("4.4. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Tên thương mại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedCommercialName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("4.5. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Mã kiểu loại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedModelCode']))])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v("5.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin xe mẫu, loại xe cở sở")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Số khung xe mẫu (số VIN)")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleVINNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Số động cơ xe mẫu")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleEngineNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Xe ô tô cơ sở (áp dụng cho xe đóng thùng)")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleVehicleTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3.1 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Số GCN xe cơ sở")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['referenceCertificateNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3.2 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Loại xe ô tô cơ sở")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleVehicleTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3.3 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Nhãn hiệu")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleTrademarkName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3.4 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Tên thương mại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleCommercialName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3.5 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Mã kiểu loại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleModelCode']))])])])])])], 1)], _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("2. THÔNG SỐ KỸ THUẬT SẢN PHẨM")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('table', {
    staticClass: "table-basic px-4 pb-2 table-tskt",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("TT")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Hạng mục kiểm tra")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Kết quả kiểm tra")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.listThongSoKyThuat), function(item, index) {
    return [_c('tr', {
      key: 'listThongSoKyThuat' + index
    }, [_c('td', {
      staticStyle: {
        "text-align": "left!important"
      },
      attrs: {
        "colspan": "3"
      }
    }, [_c('label', [_vm._v(_vm._s(item['title']))])])]), _vm._v(" "), _vm._l((item['items']), function(itemTSKT, indexTSKT) {
      return _c('tr', {
        key: 'listThongSoKyThuat_item' + indexTSKT
      }, [_c('td', {
        staticClass: "text-xs-center"
      }, [_vm._v("\n                            " + _vm._s(indexTSKT + 1) + "\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                                    "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(itemTSKT['title'])
        }
      })]), _vm._v(" "), _c('td', {
        staticClass: "text-xs-center"
      }, [_vm._v("\n                              " + _vm._s(itemTSKT['value']) + "\n                          ")])])
    })]
  })], 2)])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("3. GHI CHÚ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('table', {
    staticClass: "table-basic px-4 pb-2 table-tskt",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_c('span', [_vm._v("3.1")])]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_c('span', [_vm._v("Ghi chú để in chứng chỉ")])]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.thongTinChungTSKT['certificateNote']))])])])])])])], 2)], 1)], 1)])], 1)], 1)], 1)], 1) : (_vm.detailPage == 2) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "#fff"
    }
  }, [_c('div', {
    staticClass: "row-header"
  }, [_c('div', {
    staticClass: "background-triangle-big"
  }, [_vm._v(" KẾT QUẢ ")]), _vm._v(" "), _c('div', {
    staticClass: "layout row wrap header_tools row-blue"
  }, [_c('div', {
    staticClass: "flex xs7 sm9 solo pl-4 pt-2 text-ellipsis"
  }, [_vm._v("\n\n        THÔNG SỐ KỸ THUẬT " + _vm._s(_vm.tenModuleTSKT) + "\n\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "flex xs5 sm3 text-right",
    staticStyle: {
      "margin-left": "auto"
    }
  }, [_c('v-btn', {
    staticClass: " my-0 py-0 btn-border-left",
    attrs: {
      "flat": "",
      "color": "grey darken-1"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.undoDetailPageTSKT()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("undo")]), _vm._v("\n          Quay lại\n        ")], 1)], 1)])]), _vm._v(" "), _c('v-expansion-panel', {
    staticClass: "my-0 opencps-dossier-info",
    attrs: {
      "expand": ""
    }
  }, [_c('v-layout', {
    staticClass: "ml-0 pl-0",
    staticStyle: {
      "padding-right": "15px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('span', [_vm._v("Số chứng chỉ")]), _vm._v(": "), _c('label', [_vm._v(_vm._s(_vm.thongTinChungTSKT['certificateRecordNo']))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('span', [_vm._v("Ngày ký")]), _vm._v(": "), _c('label', [_vm._v(_vm._s(_vm.parseTimeStampToDate(_vm.thongTinChungTSKT['certificateRecordDate'])))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('span', [_vm._v("Đăng kiểm viên chính")]), _vm._v(": "), _c('label', [_vm._v(_vm._s(_vm.thongTinChungTSKT['inspectorName'] || _vm.thongTinChungTSKT['inspectorSignName']))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('span', [_vm._v("Số biên bản kiểm tra")]), _vm._v(": "), _c('label', [_vm._v(_vm._s(_vm.thongTinChungTSKT['inspectionRecordNo'] || _vm.thongTinChungTSKT['verificationRefNo']))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('span', [_vm._v("Ngày kiểm tra")]), _vm._v(": "), _c('label', [_vm._v(_vm._s(_vm.thongTinChungTSKT['inspectionRecordNo'] ? _vm.parseTimeStampToDate(_vm.thongTinChungTSKT['inspectionDate']) : _vm.parseTimeStampToDate(_vm.thongTinChungTSKT['verificationRefDate'])))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('span', [_vm._v("Loại hồ sơ")]), _vm._v(": "), _c('label', [_vm._v(_vm._s(_vm.thongTinChungTSKT['dossierTypeDescription']))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }), _vm._v(" "), (_vm.thongTinChungTSKT['serviceCode'] == 'TT302011BGTVTTDTKXCG' && _vm.thongTinChungTSKT['designModelDescription']) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_vm._v("\n        Loại hình thiết kế: "), _c('label', [_vm._v(_vm._s(_vm.thongTinChungTSKT['designModelDescription']))])]) : _vm._e(), _vm._v(" "), (_vm.thongTinChungTSKT['serviceCode'] == 'TT302011BGTVTTDTKXCG') ? [_c('v-layout', {
    staticClass: "ml-0 pl-0",
    staticStyle: {
      "padding-right": "15px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("1. THÔNG TIN CHUNG")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('table', {
    staticClass: "table-basic px-4 pb-2 table-tskt",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("TT")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Hạng mục")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Nội dung")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('label', [_vm._v("1.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Cơ sở thiết kế")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Tên")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['applicantName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Địa chỉ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['applicantAddress']))])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v("5.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin chung về kiểu loại xe")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Ký hiệu thiết kế")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['designSymbol']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Loại phương tiện")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedVehicleTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Nhãn hiệu")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedTrademarkName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.4. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Tên thương mại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedCommercialName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.5. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Mã kiểu loại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedModelCode']))])])])])])], 1)] : (_vm.listServiceToanXe.includes(_vm.thongTinChungTSKT['serviceCode'])) ? [_c('v-layout', {
    staticClass: "ml-0 pl-0",
    staticStyle: {
      "padding-right": "15px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("1. THÔNG TIN CHUNG")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('table', {
    staticClass: "table-basic px-4 pb-2 table-tskt",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("TT")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Hạng mục")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Nội dung")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('label', [_vm._v("1.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin về cơ sở sản xuất")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Cơ sở sản xuất, lắp ráp")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['applicantName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.1.1 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Địa chỉ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['applicantAddress']))])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v("6.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin chung về kiểu loại xe")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("6.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Loại phương tiện")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedVehicleTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("6.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Nhãn hiệu")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedTrademarkName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("6.3. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Tên thương mại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedCommercialName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("6.4. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Mã kiểu loại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedModelCode']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("6.5. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Loại hình sản xuất, lắp ráp")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedAssemblyTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("6.6. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Mã số VIN")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedVINNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("6.6.1 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Mô tả vị trí đóng")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedVINPosition']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("6.7. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Mã số khung")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedFrameNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("6.7.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Nơi đóng số khung")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedFrameAttachPlace']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("6.8. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Mã số động cơ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedEngineNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("6.8.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Nơi đóng số động cơ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedEngineAttachPlace']))])])])])])], 1)] : (_vm.listServiceLinhKien.includes(_vm.thongTinChungTSKT['serviceCode'])) ? [_c('v-layout', {
    staticClass: "ml-0 pl-0",
    staticStyle: {
      "padding-right": "15px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("1. THÔNG TIN CHUNG")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('table', {
    staticClass: "table-basic px-4 pb-2 table-tskt",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("TT")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Hạng mục")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Nội dung")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('label', [_vm._v("1.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin về cơ sở sản xuất")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Cơ sở sản xuất, lắp ráp")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['applicantName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.1.1 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Địa chỉ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['applicantAddress']))])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v("5.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin chung về kiểu loại sản phẩm")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Loại sản phẩm")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedVehicleTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Nhãn hiệu")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedTrademarkName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Tên thương mại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedCommercialName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.4. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Mã kiểu loại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedModelCode']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.5. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Loại hình sản xuất, lắp ráp")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedAssemblyTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.5. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Ký hiệu thiết kế/ ký hiệu sản phẩm")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n                    " + _vm._s(_vm.thongTinChungTSKT['designSymbol']) + "\n                  ")])])])])])], 1)] : (_vm.listServiceSPM.includes(_vm.thongTinChungTSKT['serviceCode'])) ? [_c('v-layout', {
    staticClass: "ml-0 pl-0",
    staticStyle: {
      "padding-right": "15px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("1. THÔNG TIN CHUNG")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('table', {
    staticClass: "table-basic px-4 pb-2 table-tskt",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("TT")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Hạng mục")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Nội dung")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('label', [_vm._v("1.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin về cơ sở sản xuất")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Cơ sở sản xuất, lắp ráp")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['applicantName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Địa chỉ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['applicantAddress']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.3. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Nhà máy sản xuất")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n                    " + _vm._s(_vm.thongTinChungTSKT['productionPlantName']) + "\n                  ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.4. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Địa chỉ nhà máy sản xuất")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['productionPlantAddress']))])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v("2.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin về chứng chỉ thẩm định thiết kế")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Số chứng chỉ thẩm định thiết kế")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['verificationCertificateNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Ngày cấp")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.parseTimeStampToDate(_vm.thongTinChungTSKT['verificationCertificateDate'])))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.3. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Ký hiệu thiết kế")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['designSymbol']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.4. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Số giấy chứng nhận phê duyệt kiểu loại tại nước ngoài")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['typeApprovalCertificateNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.4. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Ngày cấp")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.parseTimeStampToDate(_vm.thongTinChungTSKT['typeApprovalCertificateDate'])))])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v("3.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin tiêu chuẩn, quy chuẩn áp dụng")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("3.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Tiêu chuẩn an toàn chung")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['commonSafetyDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("3.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Tiêu chuẩn khí thải")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['emissionDescription']))])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v("4.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin chung về kiểu loại xe")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("4.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Loại hình sản xuất, lắp ráp")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedAssemblyTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("4.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Loại phương tiện")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedVehicleTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Nhãn hiệu")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedTrademarkName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("4.4. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Tên thương mại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedCommercialName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("4.5. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Mã kiểu loại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedModelCode']))])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v("5.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin xe mẫu, loại xe cở sở")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Số khung xe mẫu (số VIN)")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleVINNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Số động cơ xe mẫu")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleEngineNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Xe ô tô cơ sở (áp dụng cho xe đóng thùng)")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleVehicleTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3.1 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Số GCN xe cơ sở")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['referenceCertificateNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3.2 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Loại xe ô tô cơ sở")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleVehicleTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3.3 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Nhãn hiệu")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleTrademarkName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3.4 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Tên thương mại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleCommercialName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3.5 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Mã kiểu loại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleModelCode']))])])])])])], 1)] : [_c('v-layout', {
    staticClass: "ml-0 pl-0",
    staticStyle: {
      "padding-right": "15px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("1. THÔNG TIN CHUNG")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('table', {
    staticClass: "table-basic px-4 pb-2 table-tskt",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("TT")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Hạng mục")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Nội dung")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('label', [_vm._v("1.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin về cơ sở sản xuất")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Cơ sở sản xuất, lắp ráp")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['applicantName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Địa chỉ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['applicantAddress']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.3. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Nhà máy sản xuất")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n                    " + _vm._s(_vm.thongTinChungTSKT['productionPlantName']) + "\n                  ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.4. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Địa chỉ nhà máy sản xuất")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['productionPlantAddress']))])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v("2.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin về chứng chỉ thẩm định thiết kế")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Số chứng chỉ thẩm định thiết kế")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['verificationCertificateNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Ngày cấp")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.parseTimeStampToDate(_vm.thongTinChungTSKT['verificationCertificateDate'])))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.3. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Ký hiệu thiết kế")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['designSymbol']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.4. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Số giấy chứng nhận phê duyệt kiểu loại tại nước ngoài")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['typeApprovalCertificateNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.4. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Ngày cấp")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.parseTimeStampToDate(_vm.thongTinChungTSKT['typeApprovalCertificateDate'])))])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v("3.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin tiêu chuẩn, quy chuẩn áp dụng")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("3.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Tiêu chuẩn an toàn chung")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['commonSafetyDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("3.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Tiêu chuẩn khí thải")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['emissionDescription']))])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v("4.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin chung về kiểu loại xe")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("4.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Loại hình sản xuất, lắp ráp")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedAssemblyTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("4.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Loại phương tiện")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedVehicleTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Nhãn hiệu")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedTrademarkName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("4.4. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Tên thương mại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedCommercialName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("4.5. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Mã kiểu loại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['certifiedModelCode']))])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v("5.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin xe mẫu, loại xe cở sở")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Số khung xe mẫu (số VIN)")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleVINNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Số động cơ xe mẫu")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleEngineNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Xe ô tô cơ sở (áp dụng cho xe đóng thùng)")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleVehicleTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3.1 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Số GCN xe cơ sở")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['referenceCertificateNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3.2 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Loại xe ô tô cơ sở")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleVehicleTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3.3 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Nhãn hiệu")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleTrademarkName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3.4 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Tên thương mại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleCommercialName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("5.3.5 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Mã kiểu loại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKT['sampleModelCode']))])])])])])], 1)], _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("2. THÔNG SỐ KỸ THUẬT SẢN PHẨM")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('table', {
    staticClass: "table-basic px-4 pb-2 table-tskt",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("TT")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Hạng mục kiểm tra")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Kết quả kiểm tra")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.listThongSoKyThuat), function(item, index) {
    return [_c('tr', {
      key: 'listThongSoKyThuat' + index
    }, [_c('td', {
      staticStyle: {
        "text-align": "left!important"
      },
      attrs: {
        "colspan": "3"
      }
    }, [_c('label', [_vm._v(_vm._s(item['title']))])])]), _vm._v(" "), _vm._l((item['items']), function(itemTSKT, indexTSKT) {
      return _c('tr', {
        key: 'listThongSoKyThuat_item' + indexTSKT
      }, [_c('td', {
        staticClass: "text-xs-center"
      }, [_vm._v("\n                  " + _vm._s(indexTSKT + 1) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                          "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(itemTSKT['title'])
        }
      })]), _vm._v(" "), _c('td', {
        staticClass: "text-xs-center"
      }, [_vm._v("\n                    " + _vm._s(itemTSKT['value']) + "\n                ")])])
    })]
  })], 2)])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("3. GHI CHÚ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('table', {
    staticClass: "table-basic px-4 pb-2 table-tskt",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_c('span', [_vm._v("3.1")])]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_c('span', [_vm._v("Ghi chú để in chứng chỉ")])]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.thongTinChungTSKT['certificateNote']))])])])])])])], 2)], 1)], 1) : (_vm.detailPage == 3) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "#fff"
    }
  }, [_c('div', {
    staticClass: "row-header"
  }, [_c('div', {
    staticClass: "background-triangle-big"
  }, [_vm._v(" KẾT QUẢ ")]), _vm._v(" "), _c('div', {
    staticClass: "layout row wrap header_tools row-blue"
  }, [_c('div', {
    staticClass: "flex xs7 sm9 solo pl-4 pt-2 text-ellipsis"
  }, [_vm._v("\n\n        THÔNG SỐ KỸ THUẬT PHƯƠNG TIỆN\n\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "flex xs5 sm3 text-right",
    staticStyle: {
      "margin-left": "auto"
    }
  }, [_c('v-btn', {
    staticClass: " my-0 py-0 btn-border-left",
    attrs: {
      "flat": "",
      "color": "grey darken-1"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.undoDetailPageTSKT()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("undo")]), _vm._v("\n          Quay lại\n        ")], 1)], 1)])]), _vm._v(" "), _c('v-expansion-panel', {
    staticClass: "my-0 opencps-dossier-info",
    attrs: {
      "expand": ""
    }
  }, [_c('v-layout', {
    staticClass: "ml-0 pl-0",
    staticStyle: {
      "padding-right": "15px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('span', [_vm._v("Số giấy chứng nhận")]), _vm._v(": "), _c('label', [_vm._v(_vm._s(_vm.thongTinChungTSKTPT['certificateRecordNo']))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('span', [_vm._v("Ngày cấp")]), _vm._v(": "), _c('label', [_vm._v(_vm._s(_vm.parseTimeStampToDate(_vm.thongTinChungTSKTPT['certificateRecordDate'])))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('span', [_vm._v("Số seri")]), _vm._v(": "), _c('label', [_vm._v(_vm._s(_vm.thongTinChungTSKTPT['serialNo']))])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "ml-0 pl-0",
    staticStyle: {
      "padding-right": "15px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("1. THÔNG TIN CHUNG")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('table', {
    staticClass: "table-basic px-4 pb-2 table-tskt",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("TT")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Hạng mục")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Nội dung")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('label', [_vm._v("1.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin về cơ sở sản xuất")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Cơ sở sản xuất, lắp ráp")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKTPT['applicantName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("1.1.1 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Địa chỉ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKTPT['applicantAddress']))])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v("2.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', [_vm._v("Thông tin chung về kiểu loại xe")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Loại phương tiện")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKTPT['certifiedVehicleTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.2. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Nhãn hiệu")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKTPT['certifiedTrademarkName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.3. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Tên thương mại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKTPT['certifiedCommercialName']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.4. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Mã kiểu loại")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKTPT['certifiedModelCode']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.5. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Loại hình sản xuất, lắp ráp")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKTPT['certifiedAssemblyTypeDescription']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.6. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Mã số VIN")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKTPT['certifiedVINNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.6.1 ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Mô tả vị trí đóng")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKTPT['certifiedVINPosition']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.7. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Mã số khung")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKTPT['certifiedFrameNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.7.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Nơi đóng số khung")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKTPT['certifiedFrameAttachPlace']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.8. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Mã số động cơ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKTPT['certifiedEngineNo']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("2.8.1. ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v("Nơi đóng số động cơ")]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.thongTinChungTSKTPT['certifiedEngineAttachPlace']))])])])])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "ml-0 pl-0",
    staticStyle: {
      "padding-right": "15px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("2. THÔNG SỐ KỸ THUẬT")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('table', {
    staticClass: "table-basic px-4 pb-2 table-tskt",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("TT")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Thông số kỹ thuật")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-center"
  }, [_vm._v("Giá trị")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.listThongSoKyThuatPT), function(item, index) {
    return [_c('tr', {
      key: 'listThongSoKyThuatPT' + index
    }, [_c('td', {
      staticStyle: {
        "text-align": "left!important"
      },
      attrs: {
        "colspan": "3"
      }
    }, [_c('label', [_vm._v(_vm._s(item['title']))])])]), _vm._v(" "), _vm._l((item['items']), function(itemTSKT, indexTSKT) {
      return _c('tr', {
        key: 'listThongSoKyThuatPT_item' + indexTSKT
      }, [_c('td', {
        staticClass: "text-xs-center"
      }, [_vm._v("\n                  " + _vm._s(indexTSKT + 1) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                          "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(itemTSKT['title'])
        }
      })]), _vm._v(" "), _c('td', {
        staticClass: "text-xs-center"
      }, [_vm._v("\n                    " + _vm._s(itemTSKT['value']) + "\n                ")])])
    })]
  })], 2)])])], 1)], 1)], 1) : (_vm.detailPage == 4) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "#fff"
    }
  }, [_c('div', {
    staticClass: "row-header"
  }, [_c('div', {
    staticClass: "background-triangle-big"
  }, [_vm._v(" KẾT QUẢ ")]), _vm._v(" "), _c('div', {
    staticClass: "layout row wrap header_tools row-blue"
  }, [(_vm.typeViewList == 1) ? _c('div', {
    staticClass: "flex xs7 sm9 solo pl-4 pt-2 text-ellipsis"
  }, [_vm._v("\n\n        ẢNH SẢN PHẨM\n\n      ")]) : _vm._e(), _vm._v(" "), (_vm.typeViewList == 2) ? _c('div', {
    staticClass: "flex xs7 sm9 solo pl-4 pt-2 text-ellipsis"
  }, [_vm._v("\n\n        BẢN VẼ\n\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex xs5 sm3 text-right",
    staticStyle: {
      "margin-left": "auto"
    }
  }, [_c('v-btn', {
    staticClass: " my-0 py-0 btn-border-left",
    attrs: {
      "flat": "",
      "color": "grey darken-1"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.undoDetailPageTSKT()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("undo")]), _vm._v("\n          Quay lại\n        ")], 1)], 1)])]), _vm._v(" "), _c('v-expansion-panel', {
    staticClass: "my-0 opencps-dossier-info",
    attrs: {
      "expand": ""
    }
  }, [_c('v-layout', {
    staticClass: "ml-0 pl-0",
    staticStyle: {
      "padding-right": "15px",
      "margin-top": "15px",
      "height": "100vh !important",
      "overflow": "auto"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-list', [(_vm.typeViewList == 1) ? _c('div', {
    staticStyle: {
      "padding-left": "5px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n            Danh sách ảnh sản phẩm\n          ")]) : _vm._e(), _vm._v(" "), (_vm.typeViewList == 2) ? _c('div', {
    staticStyle: {
      "padding-left": "5px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n            Danh sách bản vẽ\n          ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listAnh), function(item, index) {
    return _c('v-list-tile', {
      key: item['id'] + 'anh',
      on: {
        "click": function($event) {
          return _vm.viewAnh(item, index)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      staticStyle: {
        "padding-left": "20px"
      }
    }, [_c('b', [_vm._v(_vm._s(index + 1) + ". ")]), _vm._v(_vm._s(item['displayName'] || '') + " "), _c('span', {
      staticStyle: {
        "font-style": "italic",
        "color": "#14bef0",
        "margin-left": "5px"
      }
    }, [_vm._v("(" + _vm._s(item['modifiedDate']) + ")")])])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "anhPdf"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    attrs: {
      "id": "notFound"
    }
  })])], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-154172f5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home_data_table.vue
// module id = 289
// module chunks = 1